<div class="request-container">
  <div class="header">
    {{orderPropaneLabel}}
    <img (click)="modalService.dismissAll()" class="close-btn" src="assets/icons/x-blue.svg">
  </div>
  <div [formGroup]="orderForm" class="content">
    <div class="notice-text">
      <span i18n="@@requestedDeliveries">Requested deliveries can take up to 1 business day before updating on your Delivery Status Tracker.</span>
    </div>
    <div class="required-text">
      <span i18n="@@allFieldsAreRequired">All fields are required unless otherwise indicated.</span>
    </div>
    <div class="info-container">
      <div class="customer-info">
        <div class="title"><span i18n="@@requestedBy">Requested By</span></div>
        <div class="info">
          <span>{{user?.fullname}}</span>
        </div>
      </div>
      <div class="customer-info">
        <div class="title"><span i18n="@@customerName">Customer Name</span></div>
        <div class="info">
          <span>{{customer?.name}}</span>
        </div>
      </div>
      <div class="customer-info">
        <div class="title"><span i18n="@@accountNumber">Account Number</span></div>
        <div class="info">
          <span>{{customer?.legacyId}}</span>
        </div>
      </div>
    </div>
    <div class="info-container">
      <div class="input-container">
        <div class="title">
          <span i18n="@@location">Location</span>
        </div>
        <div class="input">
          <avenir-select class="select-location" [showLabel]="false" [options]="locations"
            [selectedOption]="locations[0]?.label || ''" (emitSelected)="onLocationSelected($event)">
          </avenir-select>
        </div>
      </div>
      <div class="input-container">
        <div class="title">
          <span i18n="@@currentTankLevelPercent">Current Tank Level</span><span> (%)</span>
        </div>
        <div class="input">
          <input id="tankLevelInput" type="number" avenirDigitOnly max="80" min="0" step="1" class="form-control" formControlName="currentTankLevel" (input)="onTankLevelChange($event)" />
        </div>
        <div class="subtext">
          {{tankLevelEstimateSubtext}}
        </div>
      </div>
      <div class="input-container">
        <div class="title justify-between">
          <div><span i18n="@@deliveryInstructions">Delivery Instructions</span></div>
          <div><span class="subtext" i18n="@@optional">Optional</span></div>
        </div>
        <div class="input">
          <textarea rows="3" class="form-control" formControlName="deliveryInstructions"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <avenir-button [size]="BUTTON_SIZE.MEDIUM" [theme]="BUTTON_THEME.GREY" [label]="btnCancelLabel"
      (onClick)="modalService.dismissAll()">
    </avenir-button>
    <avenir-button [disabled]="!isTankLevelValid || !isLocationValid" [size]="BUTTON_SIZE.MEDIUM" [theme]="BUTTON_THEME.BLUE" [label]="btnSubmitLabel"
      (onClick)="submitOrderRequest()">
    </avenir-button>
  </div>
</div>